import {railStates} from './../../../ukrail/ukrail-routes';

export default function UkRailOnewayBaseController(
    $scope,
    $state,
    $stateParams,
    railsFactory,
    railsUtils,
    timeService,
    l10nService,
    moment,
) {
    'ngInject';

    const departTimeWatcher = function() {
        railsUtils.departureTimeWatcher(
            $scope.params.RailTicketSearchSegments[0]._date,
            $scope.options.time0,
            $scope.params.RailTicketSearchSegments[0]._time,
            $scope.options.time
        );
    };

    $scope.flightType = 'oneway';
    $scope.showOptions = railsUtils.moreOptionsApplied($scope.params);
    $scope.params.ReturnOrSingleJourney = 'S';
    $scope.moment = moment;

    $scope.updateArrival = function(isArrival) {
        $scope.params.RailTicketSearchSegments[0]._isArrivalTime = isArrival;
    };

    $scope.$watch('params.RailTicketSearchSegments[0]._date', departTimeWatcher);
    $scope.$watch(
        'params.RailTicketSearchSegments[0]._date',
        railsUtils.refreshReturnedDate.bind($scope.params.RailTicketSearchSegments)
    );

    const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate($scope.params.RailTicketSearchSegments[0]._date);
    const previousSearches = (function() {
        let allSearchesFetched = false;

        return {
            fetchTop: function() {
                railsFactory.getTopPreviousSearches(0).then(function(response) {
                    $scope.previousSearches = response.data;
                });
            },
            fetchAll: function() {
                if (allSearchesFetched) {
                    return;
                }

                railsFactory.getAllPreviousSearches(0).then(function(response) {
                    $scope.previousSearches = response.data;
                    allSearchesFetched = true;
                });
            },
        };
    }());

    $scope.optionsDepart = {
        placeholder: l10nService.localize('Date'),
        required: true,
        months: 2,
        before: railsFactory.getMaxBookDate(),
        start: initialDepartDate,
        after: moment().hours() >= _.last($scope.options.time).startHour
            ? moment()
            : moment().add({days: -1}),
    };

    $scope.previousSearches = [];
    $scope.maxPreviousSearches = railsFactory.TOP_PREV_SEARCHES_LIMIT;
    $scope.allPreviousResultsShown = function() {
        return $scope.maxPreviousSearches === railsFactory.ALL_PREV_SEARCHES_LIMIT;
    };
    $scope.togglePreviousSearches = function() {
        previousSearches.fetchAll();
        $scope.maxPreviousSearches = $scope.allPreviousResultsShown()
            ? railsFactory.TOP_PREV_SEARCHES_LIMIT
            : railsFactory.ALL_PREV_SEARCHES_LIMIT;
    };
    $scope.findFlights = function() {
        $scope.params.flightType = 'oneway';
        $scope.params.resetPagination();

        const params = angular.copy($scope.params);
        const paramsPrepared = false;
        const arrivalFlags = {outbound: $scope.params.RailTicketSearchSegments[0]._isArrivalTime};

        const stateParams = {
            rebook: $stateParams.rebook,
        };

        if (stateParams.rebook && stateParams.rebook.isEuRails) {
            railsFactory.fetchExchangeRails(params,
                stateParams.rebook.railRecommendationId,
                stateParams.rebook.selectedChangeable.SectionId,
                stateParams.rebook.selectedChangeable.Units,
                stateParams.rebook.selectedChangeable.Classification)
                .then(() => $state.go(railStates.EUROPEANRESULTS, stateParams));
        } else {
            railsFactory.fetchRails(params, paramsPrepared, arrivalFlags)
                .then((data) => $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS, stateParams));
        }
    };

    $scope.repeatSearch = function(search, type, options) {
        // set open state of 'more options' panel
        $scope.showOptions = railsUtils.moreOptionsApplied(search);

        railsFactory.getSearch(search.Id)
            .then(function(res) {
                angular.forEach(res.data.RailTicketSearchSegments, function(segment, i) {
                    segment.IsDepartureCity = search.SearchSegments[i].IsDeparturePointCity;
                    segment.IsArrivalCity = search.SearchSegments[i].IsArrivalPointCity;
                });

                $scope.updateArrival(res.data.RailTicketSearchSegments[0].DayTimeFilterSource);

                railsFactory.params.recreate(search, res.data, options, type);
                return railsFactory.fetchRails(res.data, true);
            })
            .then((data) => $state.go(data.EuropeanRails ? railStates.EUROPEANRESULTS : railStates.RESULTS));
    };

    previousSearches.fetchTop();
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/railonewayBaseCtrl.js